import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import auth from './modules/auth';
import users from './modules/users';
import transactions from './modules/transactions';
import reports from './modules/reports';
import gstReports from './modules/gst-reports';
import invoices from './modules/invoices';
import quotations from './modules/quotations';
import business from './modules/business';
import customers from './modules/customers';
import vendors from './modules/vendors';
import purchases from './modules/purchases';
import creditNotes from './modules/credit-notes';
import debitNotes from './modules/debit-notes';
import terms from './modules/terms';
import bank from './modules/bank';
import products from './modules/products';
import ticket from './modules/ticket';
import renewal from './modules/renewal';
import renewalPayments from './modules/renewal-payments';
import team from './modules/team';
import accounts from './modules/accounts';
import ledgerReports from './modules/ledger-reports';
import openingBalances from './modules/opening-balances';
import reconciliation from './modules/reconciliation';
import bankReconciliation from './modules/bank-reconciliation';
import fixedAssets from './modules/fixed-assets';
import employees from './modules/employees';
import payroll from './modules/payroll';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    auth,
    users,
    transactions,
    reports,
    gstReports,
    invoices,
    quotations,
    business,
    customers,
    vendors,
    purchases,
    creditNotes,
    debitNotes,
    terms,
    bank,
    products,
    ticket,
    renewal,
    renewalPayments,
    team,
    accounts,
    ledgerReports,
    openingBalances,
    reconciliation,
    bankReconciliation,
    fixedAssets,
    employees,
    payroll
  },
});
